module.exports = __webpack_public_path__ + "img/code2.8156e1ac.png";